import { render, staticRenderFns } from "./subjectHome.vue?vue&type=template&id=37e15553"
import script from "./subjectHome.vue?vue&type=script&lang=js"
export * from "./subjectHome.vue?vue&type=script&lang=js"
import style0 from "./subjectHome.vue?vue&type=style&index=0&id=37e15553&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports